import React from 'react';
import CreatableSelect from 'react-select/creatable';
import '../../shared/ReactSelectDarkMode.css';

/** Shared static creatable select with the project's consistent CSS hooks. */
export default function AppCreatableSelect({
  className = 'react-select-container',
  classNamePrefix = 'react-select',
  ...props
}) {
  return <CreatableSelect className={className} classNamePrefix={classNamePrefix} {...props} />;
}
